module.exports = __webpack_public_path__ + "static/img/hospital.1c0e159e.png";